import {CURRENCY} from './currency';

const PROVINCE_LOCALE = {
  zh: 1,
  'zh-TW': 1,
  en: 2,
  'en-US': 2,
  hk: 3,
  'zh-HK': 3,
  my: 4,
  'zh-CN': 4,
  pl: 5,
  'pl-PL': 5,
  kg: 6,
};
PROVINCE_LOCALE.DEFAULT = PROVINCE_LOCALE.zh;

const PROVINCE = {
  1: {value: 'tw', label: '台灣', currency: CURRENCY.TWD},
  2: {value: 'us', label: '美國', currency: CURRENCY.USD},
  3: {value: 'hk', label: '香港', currency: CURRENCY.HKD},
  4: {value: 'my', label: '馬來西亞', currency: CURRENCY.MYR},
  5: {value: 'pl', label: '波蘭', currency: CURRENCY.EUR},
  6: {value: 'kg', label: '吉爾吉斯', currency: CURRENCY.USD},
};
PROVINCE.DEFAULT = PROVINCE[1];

export {PROVINCE_LOCALE, PROVINCE};
